import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { setSortBy } from "../../appState/slices/auth/authSlice";

const SortByDropDown = () => {
    const sortby = useSelector((state) => state.auth.category.sortby);
    const dispatch = useDispatch();
    const updateSortby = (value) => {
     dispatch(setSortBy(value));
    }
    return (
        <div className="sortbydropdown">
            {/* <div className="sortbypill">
                Recommended
            </div> */}
            <div className={`${sortby === "newest"? "productsizeselected" : ""} sortbypill`} onClick={() => updateSortby("newest")}> 
                Newest
            </div>
            <div className={`${sortby === "lowPrice"? "productsizeselected" : ""} sortbypill`} onClick={() => updateSortby("lowPrice")}>
                Low Price
            </div>
            <div className={`${sortby === "highPrice"? "productsizeselected" : ""} sortbypill`} onClick={() => updateSortby("highPrice")}>
                High Price
            </div>
        </div>
    );
};

export default SortByDropDown;